import React, { useState, useEffect, useRef, useMemo } from 'react';
import moment from 'moment';
import { Row, Col, Form, Select, Space, Spin, message, Drawer, Modal } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import {
    getAllCustomGroupByEntity, findAllCustomOptionsByDropdown,
    findAllCustomFieldsByGroupAndEntity,
} from '../../../Api/Services/CustomeUIApiService';
import { getStateData, getCityData, getCountryData, getAllUsersData } from '../../../Api/Services/CommonApiService';
import { FetchContactByAccount, createContacts } from '../../../Api/Services/ContactApiService';
import { FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { convertCurrency } from '../Filters/FilterConditions';
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import AllCancelPopup from '../Popup/AllCancelPopup';
import { CancelIcon, SaveIcon } from '../../../components/Icons/Icons';
import CommonFormFields from '../CustomizeUi/DynamicFieldGroup';

const { Option } = Select;

const LEAD_SPECIAL_FIELDS = {
    leadOwner: ({ users }) => (
        <Select
            style={{ width: '100%' }}
            placeholder="Select Contact Owner"
            showSearch
            optionLabelProp="label"
            filterOption={(input, option) => {
                const el = option.children.props.children[1].props.children[0];
                if (el?.props?.children) {
                    return String(el.props.children).toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }}
        >
            {users}
        </Select>
    ),
    accountId: ({ form, account, handleAccountChange }) => (
        <Select style={{ width: '100%' }}
            placeholder="Select Account Name"
            showSearch optionLabelProp="label"
            optionFilterProp="children"
            filterOption={(input, option) => {
                const usernameElement = option.children.props.children[1].props.children[0];
                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                    const username = String(usernameElement.props.children);
                    return username.toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }
            }
            onChange={(value) => {
                handleAccountChange(value);
                form.setFieldsValue({
                    reportingTo: null
                })
            }}>
            {account.filter((item) => item.accountTypeName === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.accountName} (${option.accountNumber})`} style={{ cursor: "default" }}>
                                {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                    < img src={option.accountProfile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.accountName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.accountName}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.accountName} (${option.accountNumber})`}>
                        <div>
                            {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                < img src={option.accountProfile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.accountName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.accountName}</p>
                            <p style={{ margin: 0 }}>{option.accountNumber}</p>
                        </div>
                    </div>
                </Option>))}
        </Select>
    ),
    reportingTo: ({ form, contact, displayData }) => (
        <Select style={{ width: '100%' }}
            placeholder="Select Reporting to"
            showSearch optionLabelProp="label"
            allowClear
            optionFilterProp="children"
            onChange={(value) => form.setFieldsValue({ reportingTo: value || null })}
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {contact.filter(item => item.contacts_id !== displayData?.contacts_id).map((option, i) => (
                <Option value={option.contacts_id} key={i}
                    label={(
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.first_name} ${option.last_name} (${option.email})`} style={{ cursor: "default" }}>
                                    {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                        < img src={option.contact_profile} alt="profile" />
                                        :
                                        <span className="image_icon ContactIcon">
                                            {option.first_name.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{`${option.first_name} ${option.last_name}`}</span>
                                </div>
                            </div>
                        </div>)} >
                    <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                        <div>
                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.first_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                            <p style={{ margin: 0 }}>{option?.email}</p>
                        </div>
                    </div>
                </Option>))
            }
        </Select>
    ),
    country: ({ allCountry, country, handleCountryChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select Country"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleCountryChange}
            value={country}
        >
            {allCountry?.map(opt => (
                <Option key={opt.countryId} value={opt.country}>{opt.country}</Option>
            ))}
        </Select>
    ),
    state: ({ allState, state, handleStateChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select State"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleStateChange}
            value={state}
        >
            {allState?.map(opt => (
                <Option key={opt.stateId} value={opt.state}>{opt.state}</Option>
            ))}
        </Select>
    ),
    city: ({ allCity, city, handleCityChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select City"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleCityChange}
            value={city}
        >
            {allCity?.map(opt => (
                <Option key={opt.cityId} value={opt.city}>{opt.city}</Option>
            ))}
        </Select>
    ),
};

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, CallBackTrigger }) {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const [form] = Form.useForm();
    const [edit, setEdit] = useState(false)
    const [displayData, setDisplayData] = useState()
    const [users, setUsers] = useState([])
    const [country, setCountry] = useState()
    const [allCountry, setAllCountry] = useState([])
    const [state, setState] = useState()
    const [allState, setAllState] = useState([])
    const [city, setCity] = useState()
    const [allCity, setAllCity] = useState([])
    const [drawerPage, setDrawerPage] = useState()
    const [editField, setEditField] = useState(false)
    const [account, setAccount] = useState([])
    const [contact, setContact] = useState([])
    const [uiReady, setUiReady] = useState(false)
    const [optionsMap, setOptionsMap] = useState({});
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'contacts')?.customEntityId
    const ProfileData = localData.profile;
    const profile = ProfileData;
    const defaultCurrency = localData.currency
    const ConvertRate = defaultCurrency?.exchangeRate;
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const [images, setImages] = useState({});
    const [deleteOptions, setDeleteOptions] = useState({});
    const [fileLists, setFileLists] = useState({});
    const [dataDisables, setDataDisables] = useState({ isDisable: false, allow: false, id: null, profile: null });
    const [allFieldStructure, setAllFieldStructure] = useState([]);
    const [customGroups, setCustomGroups] = useState([]);
    const [customFields, setCustomFields] = useState();
    const setImage = (fieldKey, url) =>
        setImages(prev => ({ ...prev, [fieldKey]: url }));
    const setDeleteOption = (fieldKey, bool) =>
        setDeleteOptions(prev => ({ ...prev, [fieldKey]: bool }));
    const setFileList = (fieldKey, list) =>
        setFileLists(prev => ({ ...prev, [fieldKey]: list }));
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;
        if (typeof a !== typeof b) return false;
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;
            return keysA.every(key => isEqual(a[key], b[key]));
        }
        return false;
    };
    const getChangedFields = (currentStructure, initialStructure) => {
        return currentStructure.filter((currField) => {
            const initField = initialStructure.find((f) => f.fieldId === currField.fieldId);
            if (!initField) return true;
            const currValue = currField.value;
            const initValue = initField.value;
            return !isEqual(currValue, initValue);
        });
    };
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleAccountChange = async (value) => {
        try {
            const response = await FetchContactByAccount(value)
            setContact(response)
        } catch (error) {
            message.error(error)
        }
    }
    const fetchCustomGroupsAndFields = async () => {
        try {
            const groups = await getAllCustomGroupByEntity(ENTITY_ID);
            const sorted = [...(groups || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            const results = await Promise.all(
                sorted.map(group => findAllCustomFieldsByGroupAndEntity(ENTITY_ID, group.customFieldGroupId))
            );
            const fieldsMap = {};
            sorted.forEach((group, index) => {
                fieldsMap[group.customFieldGroupId] = [...(results[index] || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            });
            const allFields = Object.values(fieldsMap).flat();
            const structure = allFields.map((field) => ({
                entityId: field.entityId,
                fieldId: field.fieldId,
                fieldKey: field.fieldKey,
                fieldType: field.fieldType,
                fieldLabel: field.fieldLabel,
                customFieldType: field.customFieldType,
                dropdownId: field.dropdownId,
                dropdownType: field.dropdownType,
                value: field.fieldType === 'MultiFileUpload' ? [] :
                    field.fieldType === "CheckBox" ? false : null,
            }));
            batchedUpdates(() => {
                setCustomGroups(sorted);
                setCustomFields(fieldsMap);
                setAllFieldStructure(structure);
            });
        } catch {
            message.error("Failed to load custom fields");
        }
    };
    const fetchDropdownOptions = async () => {
        // Collect all unique dropdownIds from all custom fields
        const allAttrs = Object.values(customFields || {}).flat();
        const dropdownIds = [...new Set(
            allAttrs
                .filter(attr => attr.dropdownId)
                .map(attr => attr.dropdownId)
        )];
        if (!dropdownIds.length) return;
        // Fetch all in parallel
        const results = await Promise.allSettled(
            dropdownIds.map(id => findAllCustomOptionsByDropdown(id))
        );
        const map = results.reduce((acc, result, index) => {
            const attr = allAttrs.find(a => a.dropdownId === dropdownIds[index]);
            if (result.status === 'fulfilled') {
                acc[dropdownIds[index]] = result.value
                    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                    .map(item => ({
                        value: item.customDropdownOptionId,
                        label: item.option,
                    }));
            } else {
                acc[dropdownIds[index]] = [];
                message.error(`Failed to load "${attr?.dropdownType}" dropdown`);
            }
            return acc;
        }, {});
        setOptionsMap(map);
    };
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            setAccount(data)
        } catch (error) {
            message.error(error)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key)
                setAllState(response);
                setState()
                setCity()
                setAllCity([])
            } catch (error) {
                message.error(error)
            }
        } else {
            setAllState([]);
            setAllCity([])
            setState()
            setCity()
        }
    }
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key)
                setAllCity(response);
                setCity()
            } catch (error) {
                message.error(error)
            }
        }
        else {
            setAllCity([]);
            setCity()
        }
    }
    const handleCityChange = (value) => {
        setCity(value)
    }
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    leadOwner: profile.userId
                });
            }
        }
    }
    const fetchAll1 = async () => {
        await Promise.allSettled([
            fetchDropdownOptions(),
        ]);
        setTimeout(() => {
            setUiReady(true);
        }, 1000);
    };
    useEffect(() => {
        if (FromPage && displayData && customFields) {
            fetchAll1();
        }
    }, [FromPage, displayData, customFields]);
    useEffect(() => {
        if (allFieldStructure.length) {
            if (FromPage) {
                const formValues = allFieldStructure
                    .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
                    .reduce((acc, item) => {
                        acc[item.fieldKey] =
                            item.fieldType === "Multi-Dropdown" ? [] :
                                item.fieldType === "CheckBox" ? false : undefined;
                        return acc;
                    }, {});
                form.setFieldsValue(formValues);
                getUserDetail()
                setImages({});
                setDeleteOptions({});
                setFileLists({});
                setStates({ ...states, selectedRowKeys: [] });
                setCountry()
                setState()
                setCity()
                setEdit(true)
                setEditField(true)
                setDisplayData("Create")
            }
        }
    }, [UrlId, FromPage, allFieldStructure]);
    const SetAccountDetails = () => {
        if (FromPage === "AccountPage") {
            form.setFieldsValue({
                accountId: dataForDeal?.AccountId
            })
            handleAccountChange(dataForDeal?.AccountId)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            SetAccountDetails(),
            getCountry(),
            UserDetailsApi(),
        ])
    };
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll();
        }
    }, [FromPage, editField, displayData]);
    useEffect(() => {
        if (FromPage) {
            scroolup();
            fetchCustomGroupsAndFields()
        }
    }, [FromPage]);
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        const formValues = allFieldStructure
            .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
            .reduce((acc, item) => {
                acc[item.fieldKey] =
                    item.fieldType === "Multi-Dropdown" ? [] :
                        item.fieldType === "CheckBox" ? false : null;
                return acc;
            }, {});
        form.setFieldsValue(formValues);
        setImages({});
        setDeleteOptions({});
        setFileLists({});
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setCountry()
        setState()
        setCity()
        if (FromPage !== "EntityUpdate" && FromPage !== "AccountPage") {
            GetAll();
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
        setUiReady(false)
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true);
        let hideMessage;
        const currentStructure = await Promise.all(
            allFieldStructure.map(async (field) => {
                let value;
                switch (field.fieldType) {
                    case 'FileUpload':
                        value = normalizeValue(images[field.fieldKey] ?? null);
                        break;
                    case 'MultiFileUpload':
                        value = fileLists[field.fieldKey] || [];
                        break;
                    case 'Date':
                        value = values[field.fieldKey]
                            ? moment(values[field.fieldKey]).format("YYYY-MM-DD")
                            : null;
                        break;
                    case 'Number':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Percentage':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Currency':
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? await convertCurrency(ConvertRate, Number(values[field.fieldKey]))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = values[field.fieldKey] && values[field.fieldKey].length > 0
                            ? values[field.fieldKey].join(",")
                            : null;
                        break;
                    case 'CheckBox':
                        value = values[field.fieldKey] ?? false;
                        break;
                    default:
                        value = normalizeValue(values[field.fieldKey] ?? null);
                        break;
                }
                return { ...field, value };
            })
        );
        const changedFields = getChangedFields(currentStructure, allFieldStructure);
        if (changedFields.length === 0) {
            message.success("Contact updated")
            setEdit(false)
            dispatch(setEditCall(false));
            setEditField(false)
            CloseDrawer()
            loadingRef.current = false;
            setDoubleClick(false)
            return;
        }
        const defaultChanges = {};
        const customFieldValues = [];
        changedFields.forEach((field) => {
            if (field.customFieldType === "Default") {
                defaultChanges[field.fieldKey] = field.value;
            } else {
                const obj = {
                    entityId: field.entityId,
                    fieldId: field.fieldId,
                    value: field.value,
                };
                customFieldValues.push(obj);
            }
        });
        const payload = {
            ...defaultChanges,
            ...(customFieldValues.length > 0 && { customFieldValues }),
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage !== "EntityUpdate") {
                const response = await createContacts(payload)
                if (response.status === 201) {
                    const isAutomation = response?.data === AutomationMessage;
                    const isApproval = response?.data === ApprovalMessage;
                    dispatch(setEditCall(false))
                    setEdit(!edit)
                    setEditField(false)
                    loadingRef.current = false;
                    setDoubleClick(false)
                    hideMessage();
                    if (isApproval) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                        setTimeout(() => {
                            CloseDrawer();
                        }, 1000);
                    } else if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data);
                        setTimeout(() => {
                            CloseDrawer();
                        }, 1000);
                    } else {
                        CloseDrawer();
                        message.success(response?.data);
                    }
                    if (FromPage === "AccountPage") {
                        CallBackTrigger("Callback")
                    }
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const PageCancel1 = () => {
        setCancelConfirmOpen(true)
    }
    const leadSharedProps = useMemo(() => ({
        form, edit, combinedUrl, UrlId, displayData,
        account, dataDisables, setDataDisables,
        allCountry, country, handleCountryChange,
        allState, state, handleStateChange,
        allCity, city, handleCityChange,
        images, setImage, users,
        deleteOptions, setDeleteOption,
        fileLists, setFileList, contact, handleAccountChange
    }), [
        form, edit, combinedUrl, UrlId, displayData, users, account, dataDisables,
        allCountry, country, allState, state, allCity, city, handleAccountChange,
        images, deleteOptions, fileLists, contact,
    ]);
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneLead" ? "Clone Contact" :
                            <span>
                                Update Contact
                                {(displayData?.firstName || displayData?.lastName) && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {`${displayData?.firstName || ''} ${displayData?.lastName || ''}`.trim()}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Contact"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={uiReady ? [
                    <div className="form_action_button">
                        <Button
                            className="gray-button" size="small"
                            onClick={() => PageCancel1()}
                        >
                            <CancelIcon height={25} width={25} />Cancel
                        </Button>
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={doubleClick} loading={doubleClick}>
                            {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? "Update" : "Save"}
                        </Button>
                    </div>] : false
                }
            >
                {uiReady ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <VerticalFormStyleWrap>
                                        <div className="add-product-block">
                                            <div style={{ margin: 40 }}>
                                                <Row gutter={15}>
                                                    <Col xs={24}>
                                                        <div className="add-product-content">
                                                            <CommonFormFields
                                                                groups={customGroups}
                                                                customFields={customFields || {}}
                                                                specialFields={LEAD_SPECIAL_FIELDS}
                                                                sharedProps={leadSharedProps}
                                                                optionsMap={optionsMap}
                                                                combinedUrl={combinedUrl}
                                                                moduleIcon="ContactIcon"
                                                                moduleLetter={displayData?.firstName?.slice(0, 1)?.toUpperCase() || 'C'}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </VerticalFormStyleWrap>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer>
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
        </>
    );
}

AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    dataForDeal: PropTypes.object.isRequired,
    CallBackTrigger: PropTypes.func.isRequired,
};
export default AddNew;